'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftAid = exports.donation = exports.stage4Values = undefined;
var _constants = require('../constants');
var stage4Values = exports.stage4Values = function stage4Values(state) {
  return state.form[_constants.stages[3].formId].values;
};
var donation = exports.donation = function donation(state) {
  return stage4Values(state).donation === 'true';
};
var giftAid = exports.giftAid = function giftAid(state) {
  return (stage4Values(state).giftAid || []).includes('true');
};